import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from '../style';
import { withRouter } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal,
  TextField,
  Button,
  CircularProgress
} from '@material-ui/core';
import { ScheduleQuickView } from './';
import moment from 'moment';
import { connect } from 'react-redux';
import empty from '../../../assets/images/empty.svg';
import { Calendar, momentLocalizer, Navigate } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { getAllPhyPtSchedulesWeekly } from 'services/ptschedules/action';
const localizer = momentLocalizer(moment);

const PTList = props => {
  const ref = useRef();
  const {
    classes,
    data,
    isfromScheduleAppointment,
    isEnableOptions,
    scheduleBtn,
    seldate,
    setFormstate,
    setSelecteddate,
    ehrID,
    locations,
    providers,
    filtervals,
    isSearchPage,
    ps,
    scroll_ps,
    modalRef,
    isModal,
  } = props;
  const [loading, setLoading] = useState(false);
  const [slots, setSlots] = useState(null);
  const [events, setEvents] = useState([]);
  const [openQV, setOpenQV] = React.useState({ showQV: false, item: null });
  const [currentDate, setCurrentDate] = useState(
    props.date ? new Date(props.date) : new Date()
  );
  const [locs, setLocs] = useState([]);
  const [pros, setPros] = useState([]);
  const [filtervalues, setFilterValues] = useState({
    location: '',
    provider: ''
  });

  const loadHomeLocalStorage = async () => {
    if (isSearchPage) {
      setFilterValues({
        location: localStorage.getItem('filterSearchScheduleLocation')
          ? localStorage.getItem('filterSearchScheduleLocation')
          : '',
        provider: localStorage.getItem('filterSearchScheduleProvider')
          ? localStorage.getItem('filterSearchScheduleProvider')
          : ''
      });
    } else {
      setFilterValues({
        location: localStorage.getItem('filterHomeScheduleLocation')
          ? localStorage.getItem('filterHomeScheduleLocation')
          : '',
        provider: localStorage.getItem('filterHomeScheduleProvider')
          ? localStorage.getItem('filterHomeScheduleProvider')
          : ''
      });
    }
  };

  useEffect(() => {
    if (props.date) {
      setCurrentDate(props.date ? new Date(props.date) : new Date());
    }
    if (seldate) {
      setCurrentDate(seldate ? new Date(seldate) : new Date());
    }
  }, [props.date, seldate])

  useEffect(() => {
    if (props.isHomeLocalStorage) {
      loadHomeLocalStorage();
    }
  }, []);

  const mapToEvents = (data = []) =>
    data.map(item => ({
      id: item.id, // or any unique key
      title: `${item.patientName || ''}${item.routePhysicianName ? ', ' + item.routePhysicianName : ''
        }`,
      start: new Date(item.timeFrom),
      end: new Date(item.timeTo),
      resource: item, // keep full object for quick view
    }));

  useEffect(() => {
    if (data && data.length > 0) {
      setEvents(mapToEvents(data));
    } else {
      setEvents([]);
    }
  }, [data, props.date]);

  useEffect(() => {
    if (filtervals) {
      setFilterValues({
        location: filtervals.location,
        provider: filtervals.provider
      });
    }
  }, [filtervals]);

  useEffect(() => {
    if (locations != undefined) {
      let locationtopush = [];
      locationtopush.push({ key: 'All Locations', value: '' });
      locations.forEach(function (item) {
        locationtopush.push({
          value: item.id,
          key:
            (item.companyname !== null ? item.companyname : '') +
            ',' +
            (item.address && item.address.address ? item.address.address : '')
        });
      });
      setLocs(locationtopush);
    }
  }, [locations]);

  useEffect(() => {
    if (providers != undefined) {
      let providertopush = [];
      providertopush.push({ key: 'All Providers', value: '' });
      providers.forEach(function (item) {
        providertopush.push({
          value: item.id,
          key:
            (item.firstname ? item.firstname : '') +
            (item.lastname ? ' ' + item.lastname : '') +
            (item.title ? ' ' + item.title : '')
        });
      });
      setPros(providertopush);
    }
  }, [providers]);

  const handleOpenQV = (event) => {
    setOpenQV({ showQV: true, item: event.resource });
  };

  const handleCloseQV = () => {
    setOpenQV({ showQV: false, item: null });
  };

  // 1) Precompute overlapping event ids
  const getOverlappingIds = events => {
    const overlaps = new Set();

    for (let i = 0; i < events.length; i++) {
      const a = events[i];
      const aStart = new Date(a.start);
      const aEnd = new Date(a.end || a.start);

      for (let j = i + 1; j < events.length; j++) {
        const b = events[j];
        const bStart = new Date(b.start);
        const bEnd = new Date(b.end || b.start);

        const isOverlap =
          aEnd > bStart && aStart < bEnd; // standard interval overlap check[web:26]

        if (isOverlap) {
          overlaps.add(a.id);
          overlaps.add(b.id);
        }
      }
    }

    return overlaps;
  };

  const overlappingIds = React.useMemo(
    () => getOverlappingIds(events),
    [events]
  );

  // 2) Use in eventPropGetter
  const eventPropGetter = event => {
    const now = new Date();
    const isPast = new Date(event.end || event.start) < now;

    const isOverlapping = overlappingIds.has(event.id);

    const bg = isOverlapping
      ? '#F9EEEE'          // overlapping
      : isPast
        ? '#f1f1f1'        // past
        : '#ACE1CE';       // normal
    const borderColor = isOverlapping
      ? '#EFD5D5'          // overlapping
      : isPast
        ? '#c8c8c8'        // past
        : '#94CFBA';

    return {
      style: {
        borderRadius: '4px',
        borderColor: borderColor,
        backgroundColor: bg,
        opacity: isPast ? 0.6 : 1,
        pointerEvents: isPast ? 'none' : 'auto',
        color: 'rgba(0,0,0,.6)',
      },
    };
  }; 

  const handleEditAppointment = item => {
    setOpenQV({ showQV: false, item: item });
    props.handleEditAppointment(item);
  };

  const handleDeleteAppointment = item => {
    setOpenQV({ showQV: false });
    props.handleDeleteAppointment(item);
  };

  const handleOpenScheduleAppointment = e => {
    e.stopPropagation();
    props.handleOpenScheduleAppointment();
  };

  const handleRangeChange = async (range, view) => {
    // week / work_week => range is [Date, ..., Date] for each day
    if (Array.isArray(range) && range.length) {
      const start = range[0];                  // first day in week
      const end = range[range.length - 1];     // last day in week

      // call your API here with start/end
      await fetchWeeklyEvents(start, end);
    }
  };

  const fetchWeeklyEvents = async (start, end) => {
    setLoading(true)
    // example: format as yyyy-MM-dd or ISO for your backend
    const startDate = moment(start).format('MM/DD/YYYY');
    const endDate = moment(end).format('MM/DD/YYYY');
    const res = await props.getAllPhyPtSchedulesWeekly(
      ehrID,
      startDate,
      endDate);
    // adapt to your actual action/response shape
    setEvents(mapToEvents(res || []));
     setLoading(false)
  };

  const handleDrpDownChange = (field, value) => {
    const newState = { ...filtervalues };
    let location, provider;
    if (field === 'location') {
      if (isSearchPage) {
        localStorage.setItem('filterSearchScheduleLocation', value);
      } else {
        localStorage.setItem('filterHomeScheduleLocation', value);
      }
      location = value;
    } else {
      location = newState.location;
    }
    if (field === 'provider') {
      if (isSearchPage) {
        localStorage.setItem('filterSearchScheduleProvider', value);
      } else {
        localStorage.setItem('filterHomeScheduleProvider', value);
      }
      provider = value;
    } else {
      provider = newState.provider;
    }
    setFilterValues({ ...filtervalues, [field]: value });
    props.handleDrpDownChange(location, provider);
  };

  const CalendarToolbar = ({ label, onNavigate, disableNav }) => {
    const goToBack = () => onNavigate(Navigate.PREVIOUS);
    const goToNext = () => onNavigate(Navigate.NEXT);
    const goToToday = () => onNavigate(Navigate.TODAY);

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          {!disableNav && (
            <>
              <button type="button" onClick={goToToday}>Today</button>
              <button type="button" onClick={goToBack}>‹</button>
              <button type="button" onClick={goToNext}>›</button>
            </>
          )}
        </span>
        <span className="rbc-toolbar-label">{label}</span>
      </div>)
  }

  const scrollTo7AM = React.useMemo(
    () => new Date(1970, 0, 1, 7, 0, 0, 0),
    []
  );

  return (
    <>
      {scheduleBtn ? (
        <Box className={classes.PTfilterWrap} style={{ padding: 10 }}>
          <Box className={classes.PTfilterLeft}>
            <TextField
              value={filtervalues.location || ''}
              name="Title"
              select
              style={{ maxWidth: 150 }}
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              onChange={event =>
                handleDrpDownChange('location', event.target.value)
              }>
              {locs &&
                locs.map(item => (
                  <option value={item.value}>{item.key}</option>
                ))}
            </TextField>
            &nbsp;
            <TextField
              value={filtervalues.provider || ''}
              name="Title"
              select
              SelectProps={{ native: true }}
              style={{ maxWidth: 125 }}
              variant="outlined"
              onChange={event =>
                handleDrpDownChange('provider', event.target.value)
              }>
              {pros &&
                pros.map(item => (
                  <option value={item.value}>{item.key}</option>
                ))}
            </TextField>
          </Box>
          <Box className={classes.PTfilterRight}>
            <Button
              onClick={props.handleOpenScheduleAppointment}
              variant="contained"
              color="primary"
              size="small"
              style={{ fontSize: 11, height: 32 }}>
              Schedule Appointment
            </Button>
          </Box>
        </Box>
      ) : null}
      {(isfromScheduleAppointment || events && events.length > 0) ? (
        <React.Fragment>
          <Calendar
            localizer={localizer}
            events={events}
            defaultView="day"
            views={['day', 'week', 'agenda']}
            date={currentDate}
            scrollToTime={scrollTo7AM}
            step={15}
            timeslots={4} // 4 * 15 = 60 minutes per big cell
            style={{ height: 600 }}
            onSelectEvent={handleOpenQV}
            onRangeChange={handleRangeChange}
            onNavigate={newDate => {              // update state when toolbar navigates
              setCurrentDate(newDate);
              setSelecteddate && setSelecteddate(newDate);
              setFormstate && setFormstate(prev => ({ ...prev, appointmentDate: newDate }));
              // if you also want to inform parent:
              // props.onDateChange && props.onDateChange(newDate);
            }}
            eventPropGetter={eventPropGetter}
            components={!isfromScheduleAppointment && {
              toolbar: props => (
                <CalendarToolbar
                  {...props}
                  disableNav={!isfromScheduleAppointment} // true => hide buttons
                />
              ),
            }}
          />
          {loading && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                backgroundColor: 'rgba(151, 151, 151, 0.4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
              }}
            >
              {/* MUI */}
              {/* <CircularProgress color="inherit" /> */}
              <CircularProgress size={30} color="inherit" />
            </div>
          )}
          <Modal
            disableBackdropClick
            open={openQV.showQV}
            onClose={handleCloseQV}
          >
            <ScheduleQuickView
              onCancel={handleCloseQV}
              item={openQV.item}
              isfromScheduleAppointment={isfromScheduleAppointment}
              handleEditAppointment={handleEditAppointment}
              handleDeleteAppointment={handleDeleteAppointment}
              isEnableOptions={isEnableOptions}
            />
          </Modal>
        </React.Fragment>
      ) : (
        <Box className={classes.emptyWrap}>
          <img src={empty} />
          <Typography>No appointments to display.</Typography>
        </Box>
      )}
    </>
  );
};

PTList.propTypes = {
  className: PropTypes.string
};

const mapDispatchToProps = { getAllPhyPtSchedulesWeekly };

const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PTList))
);
